module.exports = __webpack_public_path__ + "img/can6.b8320001.png";